var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m6 0h20c3.3 0 6 2.7 6 6v20c0 3.3-2.7 6-6 6h-20c-3.3 0-6-2.7-6-6v-20c0-3.3 2.7-6 6-6z",
    fill: "#963e97"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m22.9 19.4h-2l-3.8-5.7h1.2l.6-.6v-4.5l-.6-.6h-4.6l-.6.6v4.6l.6.6h1.2l-3.8 5.7h-2l-.6.5v3.4l.6.6h3.5l.6-.6v-3.4l-.6-.6h-.1l3.5-5.3 3.5 5.3h-.1l-.5.6v3.4l.6.6h3.5l.6-.6v-3.4zm-8.6-6.8v-3.5h3.5v3.4h-3.5zm-2.3 8v2.3h-2.3v-2.3zm10.3 2.3h-2.3v-2.3h2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m18 9h-4v4h4zm-9 11h3v3h-3zm11 0h3v3h-3z",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChange);
export default __webpack_public_path__ + "static/media/change.dc844bbc3d33404347687b17151b516e.svg";
export { ForwardRef as ReactComponent };